import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import {
  fetchMainMenu,
  setMainMenuMode,
  fetchClientMenu,
} from 'services/dynamicjson';

export default function Home(props) {
  let location = useLocation();
  const [firstLink, setFirstLink] = React.useState(null);
  const [error, setError] = React.useState(null);
  React.useEffect(() => {
    if (location.pathname.match(/\/advanced/)) {
      setMainMenuMode('advanced');
    }
    fetchClientMenu()
      .then((menuLinks) =>
        setFirstLink(
          () =>
            menuLinks[0] &&
            menuLinks[0].items &&
            (menuLinks[0].items[0].children
              ? menuLinks[0].items[0].children[0]
              : menuLinks[0].items[0])
        )
      )
      .catch(setError);
  }, [location]);

  if (error && error.errorCode === 1001) {
    // TODO: a better solution similar to ErrorBoundary (for hooks/async)
    alert(error.userMessage);
    return <Redirect to="/logout" />;
  }
  return !!firstLink && <Redirect to={firstLink.href} />;
}
